
import { validationMixin } from "vuelidate";
import PosData, { PosDataRequired } from "./PosData";
import { mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-pos-form",
  props: {
    url: {
      type: String,
    },
    pos: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      modelos: [],
    };
  },
  validations: {
    form: PosDataRequired,
  },
  watch: {
    pos(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  methods: {
    setNutsPay() {
      this.form.nuts_pay = this.form.nuts_pay == true ? false : true;
      if (this.form.nuts_pay) this.form.usar_smart_tef = false;
    },
    setSmartTef() {
      this.form.usar_smart_tef = !this.form.usar_smart_tef;
      if (this.form.usar_smart_tef) this.form.nuts_pay = false;
    },
    setAtivo() {
      this.form.status = this.form.status == true ? false : true;
    },
    async getDataInit() {
      this.form = await new PosData({});
      this.getModelosPos().then((data) => (this.modelos = data));
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_novo_terminal"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }
        if (!this.form.modelo) {
          this.$toast.error("Selecione o modelo do terminal.");
          return;
        }
        if (
          this.form.usar_smart_tef &&
          !this.form.smart_tef_configurado &&
          (!this.form.smart_tef_token || !this.form.smart_tef_gateway_token)
        ) {
          this.$toast.error("Informe o Token da loja e o Gateway Token.");
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        if (this.form.nuts_pay) {
          this.form.password = 1;
          this.form.username = 1;
        }

        const payload = { ...this.form };
        delete payload.smart_tef_configurado;
        if (!payload.smart_tef_token) delete payload.smart_tef_token;
        if (!payload.smart_tef_gateway_token)
          delete payload.smart_tef_gateway_token;
        await this.$http.post(this.url, payload);

        this.$router.push({ name: "posLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
